var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 88,
    viewBox: "0 0 98 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1672",
    filter: "url(#filter0_d_1909_7289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 17",
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0411,
    cy: 21.6959,
    r: 11.5357,
    fill: "#A4A9B5"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    cx: 56.959,
    cy: 21.6138,
    r: 11.5357,
    fill: "#667085"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 24",
    style: {
      mixBlendMode: "lighten"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.8619,
    cy: 21.6959,
    r: 11.5357,
    fill: "#CBD6E9"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 40.4381,
    cy: 18.3707,
    r: 14.3707,
    fill: "#667085"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 22",
    d: "M77.1467 55.5351C77.1467 66.6843 68.1084 55.5351 56.9592 55.5351C45.81 55.5351 36.7717 66.6843 36.7717 55.5351C36.7717 44.3859 45.81 35.3477 56.9592 35.3477C68.1084 35.3477 77.1467 44.3859 77.1467 55.5351Z",
    fill: "#667085"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 18",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2284 55.6132C45.2284 66.7625 36.1902 56.5229 25.041 56.5229C13.8918 56.5229 4.85352 66.7625 4.85352 55.6132C4.85352 44.464 13.8918 35.4258 25.041 35.4258C36.1902 35.4258 45.2284 44.464 45.2284 55.6132Z",
    fill: "#A4A9B5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 20",
    style: {
      mixBlendMode: "lighten"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0495 55.6132C77.0495 66.7625 68.0113 55.6132 56.862 55.6132C45.7128 55.6132 36.6746 66.7625 36.6746 55.6132C36.6746 44.464 45.7128 35.4258 56.862 35.4258C68.0113 35.4258 77.0495 44.464 77.0495 55.6132Z",
    fill: "#CBD6E9"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 16",
    d: "M65.5871 60.6253C65.5871 74.5146 54.3276 64.5152 40.4383 64.5152C26.549 64.5152 15.2896 74.5146 15.2896 60.6253C15.2896 46.7361 26.549 35.4766 40.4383 35.4766C54.3276 35.4766 65.5871 46.7361 65.5871 60.6253Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1909_7289",
    x: 0.853516,
    y: 0,
    width: 96.2932,
    height: 87.9961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.498039 0 0 0 0 0.619608 0 0 0 0 0.811765 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_7289"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_7289",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.69646da2031e0c4532dc4e10c875f835.svg";
export { ForwardRef as ReactComponent };